import { useIntegrationSettingsData } from '~/hooks/useIntegrationSettings';
import { useZendeskParams } from './useZendeskParams';

export function useIsCurrentZendesk() {
  const zendeskParams = useZendeskParams();
  const { data } = useIntegrationSettingsData();
  const { zendeskConfig } = data ?? {};

  const isCurrentInstall =
    zendeskConfig?.subdomain === zendeskParams?.subdomain &&
    zendeskConfig?.installationId === zendeskParams?.installationId;

  return isCurrentInstall;
}
